import React, { useReducer } from 'react';
import { MetricConfiguration } from '@Models/MetricConfiguration';
import { Organisation } from '@Models/Organisation';
import { SurveyFrequency, SurveyDay } from '@Models/SurveyFrequency';
import { BasicSubscriptionInfo } from '@Models/BasicSubscriptionInfo';
import { SubscriptionStatus } from '@Models/SubscriptionStatus';
import { Team } from '@Models/Team';

type State = {
    organisation: Organisation;
};

export type OrganisationManagerAction = {
    type: string;
    stringValue?: string;
    teamId?: string;
    team?: Team;
}
export enum OrganisationManagerActionType {
    NameChanged = "NAME_CHANGED",
    TeamDeleted = "TEAM_DELETED",
    TeamUpserted = "TEAM_UPSERTED",
    UpdateLogo = "UPDATE_LOGO",
    SubscriptionStatusChanged = "SUB_STATUS_CHANGE"
}

const emptyState: State = {
    organisation: new Organisation('ERROR', 'ERROR', undefined, {}, new BasicSubscriptionInfo('xxx', 'startup', '$tbc', 'Pending'))
}

type ContextType = State & {
    dispatch: React.Dispatch<OrganisationManagerAction>
};

export const OrganisationManagerContext = React.createContext<ContextType>({
    ...emptyState,
    dispatch: () => { }
});

function reducer(state: State, action: OrganisationManagerAction): State {
    switch (action.type) {
        case OrganisationManagerActionType.NameChanged: {
            const newOrg = state.organisation.cloneWithNewName(action.stringValue);
            return { organisation: newOrg };
        }
        case OrganisationManagerActionType.UpdateLogo: {
            const newOrg = state.organisation.cloneWithNewLogo(action.stringValue);
            return { organisation: newOrg };
        }
        case OrganisationManagerActionType.TeamDeleted: {
            delete state.organisation.teams[action.teamId];
            return { organisation: state.organisation };
        }
        case OrganisationManagerActionType.TeamUpserted: {
            state.organisation.teams[action.teamId] = action.team;
            return { organisation: state.organisation };
        }
        
        case OrganisationManagerActionType.SubscriptionStatusChanged: {
            const newOrg = state.organisation.cloneWithNewSubscription(new BasicSubscriptionInfo(
                state.organisation.subscription.planId,
                state.organisation.subscription.description,
                state.organisation.subscription.price,
                action.stringValue as SubscriptionStatus
            ));
            return { organisation: newOrg };
        }
        
        default:
            return state;
    }
}

export function OrganisationManagerContextProvider(props: { children: JSX.Element[] | JSX.Element, initialState?: State }) {
    const [state, dispatch] = useReducer(reducer, props.initialState || emptyState);
    const value = { ...state, dispatch };
    return <OrganisationManagerContext.Provider value={value}>{props.children}</OrganisationManagerContext.Provider>;
}
